import { render, staticRenderFns } from "./stickers.vue?vue&type=template&id=f521b678"
import script from "./stickers.vue?vue&type=script&lang=js"
export * from "./stickers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports